import { useEffect, useState } from "react";
import { celularRegex } from "app/utils/regexps";
import { useEmpresa } from "app/contexts";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "app/components/container";
import { Row } from "app/components/row";
import { Column } from "app/components/column";
import { Input } from "app/components/input";
import { Checkbox } from "app/components/checkbox";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { ConditionalButton } from "app/components/buttons";
import { Button } from "app/components/button";
import { CardHeader } from "app/components/card-header";
import { CardFooter } from "app/components/card-footer";
import { CardBody } from "app/components/card-body";

import toast from "react-hot-toast";
import { RouteError } from "app/components/route-error";

const initialState = {
  celular: {
    celular_numero: "",
    celular_principal: false,
  },
  error: null,
};

export function CelularForm() {
  const params = useParams();
  const navigate = useNavigate();

  const { addCelular, getCelular, updateCelular } = useEmpresa();

  const [state, setState] = useState(initialState);

  useEffect(() => {
    try {
      if (!!params.index) {
        const celular = getCelular(parseInt(params.index));

        setState((state) => ({
          ...state,
          celular,
        }));
      }
    } catch (error) {
      setState((state) => ({ ...state, error }));
    }
  }, [params.index, getCelular]);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!params.index) {
        const updated = updateCelular(parseInt(params.index), state.celular);

        if (!!updated) {
          toast.success("¡Número de celular actualizado!");

          return navigate("../../");
        }
      } else {
        const added = addCelular(state.celular);

        if (!!added) {
          toast.success("¡Número de celular agregado!");

          return navigate("../../");
        }
      }
    } catch (error) {
      return toast.error(error.message);
    }
  }

  if (!!state.error) {
    return <RouteError message={state.error.message} navigateTo="../../" />;
  }

  return (
    <div className="col-sm-12 col-xl-6 offset-xl-3">
      <form className="card" onSubmit={handleSubmit}>
        <CardHeader
          header={`${!!params.index ? "Editar" : "Agregar"} número de celular`}
        />

        <CardBody>
          <Container>
            <Row>
              <Column>
                <Input
                  placeholder="Número de celular"
                  value={state.celular.celular_numero}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      celular: {
                        ...state.celular,
                        celular_numero: e.target.value.trim(),
                      },
                    }))
                  }
                  title="p. ej. 9898-3214 o 3336-8080"
                  pattern={celularRegex.source}
                  autoFocus
                />
              </Column>

              <Column>
                <Checkbox
                  label="¿Es un número de celular principal?"
                  checked={state.celular.celular_principal}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      celular: {
                        ...state.celular,
                        celular_principal: e.target.checked,
                      },
                    }))
                  }
                />
              </Column>
            </Row>
          </Container>
        </CardBody>

        <CardFooter>
          <DFlexResponsive justifyContent="end">
            <ConditionalButton
              type="submit"
              condition={!params.index}
              titleWhenTrue="Agregar"
              titleWhenFalse="Actualizar"
            />

            <Button
              color="secondary"
              title="Cancelar"
              outline
              onClick={() => navigate("../../")}
            />
          </DFlexResponsive>
        </CardFooter>
      </form>
    </div>
  );
}
